import React from 'react';
import Icon from '../../../components/AppIcon';

const getUtilizationColor = (pct) => {
  if (pct > 100) return { bar: 'bg-red-500', text: 'text-red-600', badge: 'bg-red-100 text-red-700' };
  if (pct >= 80) return { bar: 'bg-amber-500', text: 'text-amber-600', badge: 'bg-amber-100 text-amber-700' };
  return { bar: 'bg-green-500', text: 'text-green-600', badge: 'bg-green-100 text-green-700' };
};

const ResourceAllocationStatus = ({ resources, loading }) => {
  if (loading) {
    return (
      <div className="bg-white rounded-lg border border-gray-200 p-6 shadow-sm">
        <div className="animate-pulse space-y-4">
          {[1,2,3]?.map(i => <div key={i} className="h-12 bg-gray-100 rounded" />)}
        </div>
      </div>
    );
  }

  const resourceList = (resources ?? [])?.slice(0, 8);

  return (
    <div className="bg-white rounded-lg border border-gray-200 shadow-sm">
      <div className="px-5 py-4 border-b border-gray-100 flex items-center justify-between">
        <h3 className="font-semibold text-gray-800 flex items-center gap-2">
          <Icon name="Users" size={16} className="text-purple-600" />
          Resource Allocation
        </h3>
        <span className="text-xs text-gray-400">{resourceList?.length} resource{resourceList?.length !== 1 ? 's' : ''}</span>
      </div>
      <div className="divide-y divide-gray-50">
        {resourceList?.length === 0 ? (
          <div className="px-5 py-8 text-center text-gray-400 text-sm">
            No resources assigned to your projects
          </div>
        ) : (
          resourceList?.map((resource, idx) => {
            const utilization = resource?.utilizationPercent ?? resource?.utilization ?? 0;
            const colors = getUtilizationColor(utilization);
            const isConflict = utilization > 100;
            return (
              <div key={resource?.id ?? idx} className="px-5 py-3">
                <div className="flex items-center justify-between mb-1.5">
                  <div className="flex items-center gap-2">
                    {isConflict && (
                      <Icon name="AlertTriangle" size={13} className="text-red-500 flex-shrink-0" />
                    )}
                    <span className="text-sm font-medium text-gray-700 truncate max-w-32">{resource?.name}</span>
                    <span className="text-xs text-gray-400">{resource?.category}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    {isConflict && (
                      <span className="text-xs bg-red-100 text-red-700 px-1.5 py-0.5 rounded font-medium">Conflict</span>
                    )}
                    <span className={`text-xs font-semibold ${colors?.text}`}>{utilization}%</span>
                  </div>
                </div>
                <div className="w-full bg-gray-100 rounded-full h-1.5">
                  <div
                    className={`h-1.5 rounded-full ${colors?.bar} transition-all`}
                    style={{ width: `${Math.min(utilization, 100)}%` }}
                  />
                </div>
                {resource?.projectCount !== undefined && (
                  <p className="text-xs text-gray-400 mt-1">{resource?.projectCount} project{resource?.projectCount !== 1 ? 's' : ''}</p>
                )}
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default ResourceAllocationStatus;
